import { render, staticRenderFns } from "./OrderAffiliateOverrides.vue?vue&type=template&id=8e9ca790&scoped=true&"
import script from "./OrderAffiliateOverrides.vue?vue&type=script&lang=js&"
export * from "./OrderAffiliateOverrides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9ca790",
  null
  
)

export default component.exports